import React from "react";
import PropTypes from "prop-types";
import { Alert, Box, Typography } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import GlassCard from "../../../components/common/GlassCard";

function getSeverityColor(severity) {
  switch (severity) {
    case "critical":
      return "error";
    case "high":
      return "warning";
    case "medium":
      return "info";
    default:
      return "success";
  }
}

function QualityAssuranceCard({ qaData }) {
  const hasFindings = qaData && qaData.findings_count > 0;

  return (
    <GlassCard title="Quality Assurance" icon={<VerifiedIcon color="primary" />} isAI>
      {hasFindings ? (
        qaData.findings.map((finding, index) => (
          <Alert
            key={`${finding.category}-${index}`}
            severity={getSeverityColor(finding.severity)}
            sx={{
              mb: 1,
              borderRadius: 2,
              background:
                "linear-gradient(135deg, rgba(139, 105, 170, 0.03) 0%, rgba(230, 230, 230, 0.03) 100%)",
            }}
          >
            <Box display="flex" alignItems="flex-start" justifyContent="space-between" gap={1}>
              <Box flex={1}>
                <Typography variant="body2" fontWeight={600} mb={0.5}>
                  {finding.finding}
                </Typography>
                <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                  Category: {finding.category} • Severity: {finding.severity}
                </Typography>
                <Box display="flex" alignItems="center" gap={0.5} sx={{ mt: 0.5 }}>
                  <LightbulbIcon sx={{ color: "success.main", fontSize: 16 }} />
                  <Typography variant="caption" sx={{ color: "success.main" }}>
                    {finding.suggestion}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Alert>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary">
          {qaData?.status === "unavailable"
            ? qaData.message || "AI check is unavailable right now."
            : qaData ? "No QA issues found - excellent documentation!" : "Loading QA checks..."}
        </Typography>
      )}
    </GlassCard>
  );
}

QualityAssuranceCard.propTypes = {
  qaData: PropTypes.shape({
    status: PropTypes.string,
    message: PropTypes.string,
    findings_count: PropTypes.number,
    findings: PropTypes.arrayOf(
      PropTypes.shape({
        category: PropTypes.string,
        severity: PropTypes.string,
        finding: PropTypes.string,
        suggestion: PropTypes.string,
      })
    ),
  }),
};

QualityAssuranceCard.defaultProps = {
  qaData: null,
};

export default QualityAssuranceCard;
